import {
  DataWarehouseAmazonS3StorageBucketHttpModel,
  DataWarehouseAzureBlobStorageBucketHttpModel,
  DataWarehouseBucketHttpModel,
  DataWarehouseGoogleCloudStorageBucketHttpModel,
} from '../models/org-space-http.model';

type BucketUrlBuilder<T extends DataWarehouseBucketHttpModel> = (bucket: T) => string;
type GoogleCloudStorageBucketUrlBuilder = BucketUrlBuilder<DataWarehouseGoogleCloudStorageBucketHttpModel>;
type AzureBlobStorageBuckeUrlBuilder = BucketUrlBuilder<DataWarehouseAzureBlobStorageBucketHttpModel>;
type AmazonS3StorageBucketUrlBuilder = BucketUrlBuilder<DataWarehouseAmazonS3StorageBucketHttpModel>;

export const buildGoogleCloudStorageUrl: GoogleCloudStorageBucketUrlBuilder = (
  bucket: DataWarehouseGoogleCloudStorageBucketHttpModel,
): string =>
  `https://console.cloud.google.com/storage/browser/${bucket.name};tab=objects?&project=${bucket.project_id}`;

export const buildAzureBlobStorageUrl: AzureBlobStorageBuckeUrlBuilder = (
  bucket: DataWarehouseAzureBlobStorageBucketHttpModel,
): string =>
  `https://portal.azure.com/#view/Microsoft_Azure_Storage/ContainerMenuBlade/~/overview/storageAccountId/%2Fsubscriptions%2F${bucket.subscription_id}%2FresourceGroups%2F${bucket.resource_group}%2Fproviders%2FMicrosoft.Storage%2FstorageAccounts%2F${bucket.account_name}/path/${bucket.container_name}`;

export const buildAmazonS3StorageUrl: AmazonS3StorageBucketUrlBuilder = (
  bucket: DataWarehouseAmazonS3StorageBucketHttpModel,
): string => `https://s3.console.aws.amazon.com/s3/buckets/${bucket.name}`;
